import React from "react";
import ContactHero from "./sections/ContactHero/ContactHero";
import BookingFlow from "./sections/BookingFlow/BookingFlow";
import ContactInfo from "./sections/ContactInfo/ContactInfo";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-page">
      <ContactHero />
      <BookingFlow />
      <ContactInfo />
    </div>
  );
};

export default Contact;
